<template>
  <div :class="['carousel bg-color', className]">
    <div class="container-fluid">
      <div class="wrapper-fixed">
        <div class="row justify-content-end">
          <div class="col-12 col-lg-8">
            <div :id="sectionID" class="section-name">Services</div>
            <h2>Partnering to Build Smarter, Better, Faster</h2>
            <div class="swiper-pagination mt-6"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="outer-carousel-wrapper container-fluid">
      <div class="wrapper-fixed">
        <!-- Swiper Container -->
        <div class="swiper" ref="swiperContainer">
  
          <ul class="swiper-wrapper" role="list">
  
            <!-- slide -->
  
            <li class="swiper-slide" role="listitem">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="xl-type weight-bold mb-0" aria-hidden="true">1/5</div>
                  <h3 class="sm-type weight-normal mb-3">Design &amp; Development</h3>
                  <h4 class="h3">Simplify Complexity with Smart eCommerce Solutions</h4>
                  <p>We create tailored eCommerce solutions that handle even the most complex product configurations. From hiding incompatible options to adjusting prices dynamically, our solutions are designed to streamline the buying process and drive conversions. With a focus on intuitive UX and UI design, we ensure every interaction is seamless, engaging, and optimized for your customers’ needs.</p>
                </div>
                <div class="col-12 col-lg-6">
                  <div id="service-animation-design-dev"></div>
                </div>
              </div>
            </li>
            
            <!-- slide -->
            
            <li class="swiper-slide" role="listitem">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="xl-type weight-bold mb-0" aria-hidden="true">2/5</div>
                  <h3 class="sm-type weight-normal mb-3">Search Engine Optimization</h3>
                  <h4 class="h3">Boost Visibility with Advanced SEO Strategies</h4>
                  <p>Our SEO expertise helps put your industrial products in the spotlight. By targeting high-impact keywords like part numbers, we ensure your offerings appear in the top search results, bringing valuable organic traffic to your site.</p>
                </div>
                <div class="col-12 col-lg-6">
                  <img src="@/assets/images/fpo-service-graphic.png" alt="FPO Service Graphic" class="img-fluid">
                </div>
              </div>
            </li>
            
            <!-- slide -->
            
            <li class="swiper-slide" role="listitem">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="xl-type weight-bold mb-0" aria-hidden="true">3/5</div>
                  <h3 class="sm-type weight-normal mb-3">Digital Marketing</h3>
                  <h4 class="h3">Optimize Campaigns with AI-Driven Marketing</h4>
                  <p>Harness the power of AI to create smarter Google Ad campaigns. Using real-time data from integrated systems, we refine targeting and improve conversion rates, delivering results that matter</p>
                </div>
                <div class="col-12 col-lg-6">
                  <img src="@/assets/images/fpo-service-graphic.png" alt="FPO Service Graphic" class="img-fluid">
                </div>
              </div>
            </li>
            
            <!-- slide -->
            
            <li class="swiper-slide" role="listitem">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="xl-type weight-bold mb-0" aria-hidden="true">4/5</div>
                  <h3 class="sm-type weight-normal mb-3">Phone Systems Integration</h3>
                  <h4 class="h3">Track ROI with Phone Call Integration</h4>
                  <p>Our phone system integration provides deep insights into customer interactions, helping you track ROI and continuously improve your sales process. From taking calls to closing deals, we ensure every step is optimized.</p>
                </div>
                <div class="col-12 col-lg-6">
                  <img src="@/assets/images/fpo-service-graphic.png" alt="FPO Service Graphic" class="img-fluid">
                </div>
              </div>
            </li>
            
            <!-- slide -->
            
            <li class="swiper-slide" role="listitem">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="xl-type weight-bold mb-0" aria-hidden="true">5/5</div>
                  <h3 class="sm-type weight-normal mb-3">Analytics &amp; Data Analysis</h3>
                  <h4 class="h3">Empower Decisions with Data-Driven Insights</h4>
                  <p>Leverage advanced analytics and ERP integration for better business decisions. From accurate order entry to instant pricing updates, our tools provide the clarity you need to maximize profitability.</p>
                </div>
                <div class="col-12 col-lg-6">
                  <img src="@/assets/images/fpo-service-graphic.png" alt="FPO Service Graphic" class="img-fluid">
                </div>
              </div>
            </li>
  
          </ul>
  
          <button ref="prevBtn" class="swiper-button-prev" aria-label="Previous Slide"> </button>
          <button ref="nextBtn" class="swiper-button-next" aria-label="Next Slide"></button>
  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import lottie from "lottie-web";
import designDevAnimation from "@/assets/images/service-animations/service-design-dev.json";

export default {
  name: "BlockCarousel",
  props: {
    className: [String, Array],
    sectionID: String,
  },
  data() {
    return {
      swiperInstance: null,
      designDevAnimation: null,
      observer: null,
      isInViewport: false,
      loopCount: 0,
      maxLoops: 3,
      isPlaying: false, // ← Track animation state
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
      this.initLottieAnimation();
      this.initIntersectionObserver();
    });
  },
  methods: {
    initSwiper() {
      this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        centeredSlides: true,
        speed: 800,
        watchOverflow: true,
        navigation: {
          nextEl: this.$refs.nextBtn,
          prevEl: this.$refs.prevBtn,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return `<button class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
          },
        },
        breakpoints: {
          576: {
            slidesPerView: 1.05,
            spaceBetween: 40,
          },
        },
        on: {
          slideChangeTransitionEnd: this.handleSlideChange,
        },
      });
    },

    initLottieAnimation() {
      this.loopCount = 0;
    
      this.designDevAnimation = lottie.loadAnimation({
        container: document.getElementById("service-animation-design-dev"),
        renderer: "svg",
        loop: false,
        autoplay: false,
        animationData: designDevAnimation,
      });
    
      // Key fix: use complete event, and restart immediately
      this.designDevAnimation.addEventListener("complete", () => {
        this.loopCount++;
        if (this.loopCount < this.maxLoops) {
          this.designDevAnimation.goToAndPlay(0, true);
        } else {
          this.isPlaying = false;
        }
      });
    
      this.handleSlideChange(); // Trigger first play if needed
    },

    initIntersectionObserver() {
      const target = document.getElementById("service-animation-design-dev");

      if (!target) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          this.isInViewport = entries[0].isIntersecting;
          this.handleSlideChange(); // React to visibility change
        },
        {
          root: null,
          threshold: 0.2,
        }
      );

      this.observer.observe(target);
    },

    handleSlideChange() {
      const activeSlide = this.$refs.swiperContainer.querySelector(".swiper-slide-active");
      const animationContainer = document.getElementById("service-animation-design-dev");
    
      const isCorrectSlide =
        activeSlide && activeSlide.contains(animationContainer) && this.isInViewport;
    
      if (isCorrectSlide && !this.isPlaying) {
        this.designDevAnimation.stop();
        this.loopCount = 0;
        this.isPlaying = true;
        this.designDevAnimation.play();
      }
    
      if (!isCorrectSlide && this.isPlaying) {
        this.designDevAnimation.stop();
        this.designDevAnimation.goToAndStop(1, true);
        this.isPlaying = false;
      }
    },
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>